import { Details } from "../../templates/details";
import { AROUNDUS } from "./constants";

export default function AroundUs() {
  return <Details title="around us" collage info={AROUNDUS} />
}